import React from 'react';

function RedBox() {
  const boxStyle = {
    backgroundColor: '#dc143c',
    width: '100px',
    height: '50px',
  };

  return (
    <div style={boxStyle}></div>
  );
}

export default RedBox;